import React, { useEffect } from "react";
import { Button, Form, Input, notification } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchStart, fetchSuccess, loginAction } from "../appRedux/actions";
import InfoPopup from "./../util/InfoPopup";
import { labelComponent } from "./../util/UtilComponents";
import SidebarLogo from "./Sidebar/SidebarLogo";
import { useGetBreakpoints } from "../hooks/useGetBreakpoints";
import { axiosInstance, BASE_API_CONFIG } from "../util/Api";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const FormItem = Form.Item;

const SignIn = () => {
  const dispatch = useDispatch();
  const loading = useSelector(({ common }) => common.loading);
  const history = useHistory();
  
  useEffect(() => {
    // Part 1: Load GTM script dynamically
    const script = document.createElement('script');
    script.innerHTML = `
               (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
         new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
         j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
         'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
         })(window,document,'script','dataLayer','GTM-WZ3NGKQQ');
    `;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script); // Cleanup (optional)
    };
  }, []);

  const onFinishFailed = (errorInfo) => {};

  // const onFinish = (values) => {
  //   dispatch(loginAction(values.email, values.password));
  // };

  const onFinish = async (values) => {
    try {
      const { email } = values;
      dispatch(fetchStart());
      const response = await axiosInstance.post(
        `${BASE_API_CONFIG.baseURL}/auth/email/login/otp`,
        {
          email: email,
        }
      );
      history.push("/loginwithemailotp", {
        email: email,
      });
      console.log("OTP sent successfully", response.data);
    } catch (error) {
      console.error("OTP error", error);
      notification.error({
        message: "Login Failed",
        description: error?.response?.data?.message || error?.message || "Something went wrong. Please try again.",
      });
    } finally {
      dispatch(fetchSuccess());
    }
  };

  const { isMobile } = useGetBreakpoints();
  
  return (
    <>
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WZ3NGKQQ"
      height="0" width="0" style={{display:"none",visibility:"hidden"}}></iframe></noscript>

      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <div
          style={{
            backgroundColor: "white",
            zIndex: 1,
            position: "relative",
          }}
        >
          <SidebarLogo />
        </div>
        <div
          className="gx-login-container"
          style={{
            backgroundImage: "url(/assets/images/Login_Page_BG_Image.png)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            flex: 1,
            display: "flex",
            alignItems: "right",
            justifyContent: "right",
            position: "relative",
            paddingRight: !isMobile ? "100px" : '0px',
          }}
        >
          <div>
            <div
              className="gx-login-content"
              style={{
                marginTop: "80px",
              }}
            >
              <div className="gx-mb-4">
                <div className="gx-login-header">Welcome Back</div>
                <p className="gx-login-description">
                  Don't have an account? &nbsp;{" "}
                  <Link className="myexim-link" to="/signup">
                    Register
                  </Link>
                </p>
              </div>
              <Form
                initialValues={{ remember: true }}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <FormItem
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  label={labelComponent("Email ", null)}
                  rules={[
                    { required: true, message: "Please input your E-mail!" },
                  ]}
                  name="email"
                >
                  <Input size="large" placeholder="Email" />
                </FormItem>
                {/* <div
                  style={{ display: "flex", justifyContent: "end" }}>
                    <Link className="myexim-link" to="/loginotpmobileno">
                      Login with OTP
                    </Link>
                </div>
                <FormItem
                  rules={[
                    { required: true, message: "Please input your Password!" },
                  ]}
                  name="password"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  label={labelComponent("Password", null)}
                >
                  <Input.Password size="large" placeholder="Password" />
                </FormItem>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    marginBottom: 15,
                  }}
                >
                  <Link className="myexim-link" to="/forgotpassword">
                    Forgot password
                  </Link>
                </div> */}
                <FormItem
                  className="gx-text-center"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    block
                    loading={loading}
                  >
                    Send OTP
                  </Button>
                </FormItem>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignIn;